import React from 'react';
import { observer } from 'mobx-react-lite';

import { useSubmissionFormStore } from 'widget/hooks/useSubmissionFormStore';

import SubmissionFormBody from './SubmissionFormBody';
import SubmissionFormLoader from './SubmissionFormLoader/SubmissionFormLoader';

const SubmissionForm: React.FC = () => {
  const submissionFormStore = useSubmissionFormStore();

  if (!submissionFormStore) {
    return <SubmissionFormLoader />;
  }

  return <SubmissionFormBody submissionFormStore={submissionFormStore} />;
};

export default observer(SubmissionForm);
